// @ts-nocheck
import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { branding } from '../../../config/branding';
import { useSidebarToggle } from './useSidebarToggle';


const NavHader = () => {
  const { isCollapsed: sideMenu, toggle: handleToogle } = useSidebarToggle();
  const logoSrc = branding.logoUrl;
  return (
    <div className="nav-header">
      <style>{`
        @media (max-width: 1299.98px) {
          [data-sidebar-style="overlay"] .nav-header {
            background: transparent !important;
            box-shadow: none !important;
            border-right: none !important;
          }

          [data-sidebar-style="overlay"] .nav-header::before {
            display: none !important;
          }

          [data-sidebar-style="overlay"] .nav-header .brand-logo {
            display: none !important;
          }

          [data-sidebar-style="overlay"] .nav-header .nav-control {
            left: 0 !important;
            right: auto !important;
            top: 0 !important;
            transform: none !important;
            width: 72px !important;
            height: 72px !important;
            padding: 0 !important;
            margin: 0 !important;
          }

          [data-sidebar-style="overlay"] .nav-header .hamburger {
            margin-left: 0 !important;
          }
        }
      `}</style>
      <Link
        to="/dashboard"
        className="brand-logo"
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          width: "100%",
          overflow: "visible",
        }}
      >
        <Fragment>
          <div
            className="wch-logo-frame"
            style={{
              padding: sideMenu ? "6px 10px" : "6px 10px",
            }}
          >
            <img
              className="brand-logo-image"
              src={sideMenu ? branding.faviconUrl : logoSrc}
              alt="B2Meet"
              style={{
                width: sideMenu ? 44 : "100%",
                maxWidth: sideMenu ? 44 : 250,
                minWidth: 0,
                maxHeight: sideMenu ? 32 : 64,
                height: "auto",
                objectFit: "contain",
                display: "block",
                marginInline: "auto",
                objectPosition: "center",
                flexShrink: 1,
              }}
            />
          </div>
        </Fragment>
      </Link>

      <div
        className="nav-control"
        onClick={handleToogle}
      >
        <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
